// hooks/useForceLoginIfRequired.js
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { groupedTools } from "../data/toolsData";

export const forceLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const allTools = Object.values(groupedTools).flat();
    const normalizedPath = location.pathname
      .replace(/^\/(en|es|zh-CN|de|fr|ja)(?=\/|$)/, "")
      .replace(/\/+$/, "") || "/";
    const currentTool = allTools.find((tool) => tool.path === normalizedPath);
    if (currentTool?.loginRequired) {
      const isLoggedIn = localStorage.getItem('authToken');
      if (!isLoggedIn) {
        const pathSegments = location.pathname.split('/');
        const locale = pathSegments[1] || 'en';
        const loginPath = `/${locale}/auth/login`;
        const redirectTarget = encodeURIComponent(location.pathname + location.search);
        navigate(`${loginPath}?redirect=${redirectTarget}`);
      }
    }
  }, [location.pathname, location.search, navigate]);
};
